export default "__VITE_ASSET__Bxy02EYm__"